import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  effect,
  input,
  output,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserFormComponent } from '../../components/user-form/user-form.component';
import { AlertsComponent, AlertsService } from '@web/shared/ui';
import { UserFormData } from '../../models/user-form-data';
import { Guid, once } from '@web/utils';
import { Observable } from 'rxjs';
import { UserDataSourceService } from '../../services/user-data-source.service';
import { HttpErrorService } from '@web/common';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-user-edit',
  imports: [CommonModule, UserFormComponent, AlertsComponent],
  templateUrl: './user-edit.component.html',
  styleUrl: './user-edit.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserEditComponent {
  private readonly userDataSource = inject(UserDataSourceService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  public readonly id = input.required<Guid>();
  public readonly submitSuccessEvent = output<void>();

  protected data$!: Observable<UserFormData>;

  public constructor() {
    effect(() => this.configureDataSource());
  }

  public handleSubmitClick(data: UserFormData): void {
    this.userDataSource
      .updateByFormData(this.id(), data)
      .pipe(once())
      .subscribe({
        next: () => {
          this.notifySubmitSuccessEvent();
        },
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  private notifySubmitSuccessEvent(): void {
    this.submitSuccessEvent.emit();
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    this.alerts.showMultiple((builder) =>
      this.httpError
        .extract(response)
        .messages()
        .map((message) => builder.buildFailure(message)),
    );
  }

  private configureDataSource(): void {
    this.data$ = this.userDataSource.fetchDetailsFormById(this.id());

    this.changeDetectorRef.detectChanges();
  }
}
